import { useEffect, useState } from "react";
import { useGetAllSolutionApi } from "../../hooks/solution/useGetAllSolutionApi";
import { Button, Input, Modal, Space, Switch, Table } from "antd";
import { useCreateSolutionApi } from "../../hooks/solution/useCreateSolutionApi";
import toast from "react-hot-toast";
import { useUpdateSolutionApi } from "../../hooks/solution/useUpdateSolutionApi";
import { useDeleteSolutionApi } from "../../hooks/solution/useDeleteSolutionApi";
import { FooterFilterMobile } from "../../components";
import { useAcceptSolutionApi } from "../../hooks/solution/useAcceptSolutionApi";

const SolutionPage = () => {
  // state
  const [listSolution, setListSolution] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenUpdate, setIsModalOpenUpdate] = useState(false);
  const [name, setName] = useState<any>();
  const [description, setDescription] = useState<any>();
  const [infoUpdate, setInfoUpdate] = useState<any>();

  // api
  const { solution } = useGetAllSolutionApi();
  const { mutate: $createNewSolution } = useCreateSolutionApi();
  const { mutate: $updateNewSolution } = useUpdateSolutionApi();
  const { mutate: $deleteSolution } = useDeleteSolutionApi();
  const { mutate: $acceptSolution } = useAcceptSolutionApi();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    $createNewSolution(
      {
        name,
        description,
        isActive: 1,
      },
      {
        onSuccess: () => {
          toast.success("Create new solution success");
          setIsModalOpen(false);
          setDescription("");
          setName("");
          return;
        },
        onError: () => {
          toast.error("Create new solution failure");
          setIsModalOpen(false);
          return;
        },
      }
    );
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // update
  const showModalUpdate = () => {
    setIsModalOpenUpdate(true);
  };

  const handleOkUpdate = async () => {
    $updateNewSolution(
      {
        description: description ? description : infoUpdate?.description,
        name: name ? name : infoUpdate?.name,
        id: infoUpdate?.id,
      },
      {
        onSuccess: () => {
          toast.success("Update Solution success");
          setIsModalOpenUpdate(false);
          setDescription("");
          setName("");
          return;
        },
        onError: () => {
          toast.error("Update Solution failure");
          setIsModalOpenUpdate(false);
          setDescription("");
          setName("");
          return;
        },
      }
    );
  };

  const handleDelete = async (id: any) => {
    $deleteSolution(
      {
        id,
      },
      {
        onSuccess: () => {
          toast.success("Delete Solution success");
          setIsModalOpenUpdate(false);
          setDescription("");
          setName("");
          return;
        },
        onError: () => {
          toast.error("Delete Solution failure");
          setIsModalOpenUpdate(false);
          setDescription("");
          setName("");
          return;
        },
      }
    );
  };

  const handleAccept = async (id: any) => {
    $acceptSolution(
      {
        id,
      },
      {
        onSuccess: () => {
          toast.success("Accept Solution success");
          return;
        },
        onError: () => {
          toast.error("Accept Solution failure");
          return;
        },
      }
    );
  };

  const handleCancelUpdate = () => {
    setIsModalOpenUpdate(false);
  };

  useEffect(() => {
    if (solution) {
      const convertData = solution?.data?.map((item: any, index: number) => {
        return {
          key: index,
          name: item?.name,
          id: item?.id,
          description: item?.description,
          isActive: item?.isActive,
        };
      });
      setListSolution(convertData);
    }
  }, [solution]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (value: any, record: any) => (
        <Switch
          defaultChecked={value}
          onChange={() => {
            handleAccept(record?.id);
          }}
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "action",
      render: (_: any, record: any) => (
        <Space size="large">
          <span
            className="cursor-pointer hover:underline font-medium"
            onClick={() => {
              {
                setInfoUpdate(record);
                setIsModalOpenUpdate(true);
              }
            }}
          >
            Update
          </span>
          <span
            className="cursor-pointer hover:underline font-medium"
            onClick={() => {
              {
                // setInfoUpdate(record);
                handleDelete(record?.id);
              }
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Update Solution"
        open={isModalOpenUpdate}
        onOk={handleOkUpdate}
        onCancel={handleCancelUpdate}
      >
        <div className="flex flex-col gap-4">
          <Input
            onChange={(e) => {
              setName(e.target.value);
            }}
            defaultValue={infoUpdate?.name}
            placeholder="Name Solution"
          />
          <Input
            onChange={(e) => {
              setDescription(e.target.value);
            }}
            defaultValue={infoUpdate?.description}
            placeholder="Description Solution"
          />
        </div>
      </Modal>
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Create New Solution"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col gap-4">
          <Input
            onChange={(e) => {
              setName(e.target.value);
            }}
            placeholder="Name Solution"
          />
          <Input
            onChange={(e) => {
              setDescription(e.target.value);
            }}
            placeholder="Description Solution"
          />
        </div>
      </Modal>
      <div className="max-lg:px-[12px]">
        <div className="flex max-lg:flex-col max-lg:mt-4 lg:items-center justify-between xl:mb-7 lg:mb-5 mb-4">
          <span className="uppercase xl:text-xl text-base font-semibold text-gray-600">
            MANAGE SOLUTION
          </span>
          <div>
            <Button
              onClick={showModal}
              color="default"
              variant="solid"
              size="middle"
            >
              CREATE SOLUTION
            </Button>
          </div>
        </div>
        <Table
          dataSource={listSolution}
          columns={columns}
          pagination={false}
        ></Table>
      </div>
      <FooterFilterMobile></FooterFilterMobile>
    </div>
  );
};

export default SolutionPage;
